import { freeUserUpgradeStep } from '../utils';

export const donationsListTour = {
  tourKey: 'donations_list',
  conditions: {
    orgTypes: ['business', 'npo'],
    userTypes: null,
    plans: null,
  },
  steps: [
    {
      // Welcome step - centered
      title: 'tours.donations-list.welcome-business.title',
      content: 'tours.donations-list.welcome-business.content',
      placement: 'center',
      showIf: (disc) => disc.orgType === 'business',
    },
    {
      title: 'tours.donations-list.welcome-npo.title',
      content: 'tours.donations-list.welcome-npo.content',
      placement: 'center',
      showIf: (disc) => disc.orgType === 'npo',
    },
    {
      target: '[data-tour="donation-date-range"]',
      title: 'tours.donations-list.date-range.title',
      content: 'tours.donations-list.date-range.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="create-donation"]',
      title: 'tours.donations-list.create.title',
      content: 'tours.donations-list.create.content',
      placement: 'bottom',
      showIf: (disc) =>
        disc.orgType === 'business' && disc.userType !== 'super-admin',
    },
    {
      target: '[data-tour="donations-table"]',
      title: 'tours.donations-list.table-business.title',
      content: 'tours.donations-list.table-business.content',
      placement: 'top',
      showIf: (disc) => disc.orgType === 'business',
    },
    {
      target: '[data-tour="donations-table"]',
      title: 'tours.donations-list.table-business.title',
      content: 'tours.donations-list.table-npo.content',
      placement: 'top',
      showIf: (disc) => disc.orgType === 'npo',
    },
    freeUserUpgradeStep,
  ],
};
